export const sharedWebSockets = {};
export const resetWebSockets = (url) => {
    // eslint-disable-next-line no-prototype-builtins
    if (url && sharedWebSockets.hasOwnProperty(url)) {
        delete sharedWebSockets[url];
    }
    else {
        for (const url in sharedWebSockets) {
            // eslint-disable-next-line no-prototype-builtins
            if (sharedWebSockets.hasOwnProperty(url)) {
                delete sharedWebSockets[url];
            }
        }
    }
};
